<template>
	<div>
		<div class="wrap">
			<Title title="投票管理"></Title>
			<div class="activity-form-wrap">
				<el-form :inline="true" class="activity-form">
					<el-form-item label="状态">
						<el-select v-model="status" @change="setSelectedOptions">
							<el-option label="全部" value=""></el-option>
							<el-option label="草稿状态" value="0"></el-option>
							<el-option label="已完成待发布" value="1"></el-option>
							<el-option label="已发布" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
					</el-form-item>
				</el-form>
				<el-button icon="el-icon-plus" size="mini" type="primary" @click="addVote">添加投票</el-button>
			</div>
			<el-table border :data="voteList" style="width: 100%">
				<!-- <el-table-column type="selection" width="55">
				</el-table-column> -->
				<el-table-column type="index" label="行号">
				</el-table-column>
				<el-table-column prop="startCompanyName" label="发起公司">
				</el-table-column>
				<el-table-column prop="vacationName" label="活动">
				</el-table-column>
				<el-table-column prop="voteName" label="名称">
				</el-table-column>
				<el-table-column label="投票类型">
					<template slot-scope="scope">
						<span v-if="scope.row.voteType==1">系统投票</span>
						<span v-if="scope.row.voteType==2">公司系统投票</span>
						<span v-if="scope.row.voteType==3">活动</span>
					</template>
				</el-table-column>
				<el-table-column label="投票时间">
					<template slot-scope="scope">
						{{scope.row.startTime | datefmt2('MM-DD HH:mm:ss')}}至{{scope.row.endTime | datefmt2('MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="投票数/参与人数">
					<template slot-scope="scope">
						{{scope.row.voteCount}}/{{scope.row.playerCount}}
					</template>
				</el-table-column>
				<el-table-column label="发布状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status==0">草稿</span>
						<span v-if="scope.row.status==1">已完成待发布</span>
						<span v-if="scope.row.status==2">已发布</span>
					</template>
				</el-table-column>
				<el-table-column prop="publishTime" label="发布时间">
					<template slot-scope="scope">
						{{scope.row.publishTime | datefmt2('YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column prop="showFlag" label="启用状态">
					<template slot-scope="scope">
						<el-switch 
						@click.native.prevent="changeShowFlag(scope.row)" 
						v-model="scope.row.showFlag"
						disabled
						active-color="#13ce66"
						inactive-color="#ff4949">
						</el-switch>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="publishStatus" label="发布状态">
					<template slot-scope="scope">
						<span v-if="scope.row.publishStatus==0">未发布</span>
						<span v-else>已发布</span>
					</template>
				</el-table-column> -->
				<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<el-dropdown>
							<span class="el-dropdown-link">
								...
							</span>
							<el-dropdown-menu slot="dropdown" class="dropdown-new">
								<el-dropdown-item @click.native="publishVote(scope)" v-if="scope.row.status=='0'" command="publish">发布</el-dropdown-item>
								<el-dropdown-item v-if="scope.row.status=='0'" @click.native="modifyVote(scope.row)">修改</el-dropdown-item>
								<el-dropdown-item @click.native="detailVote(scope.row)">详情</el-dropdown-item>
								<el-dropdown-item @click.native="deleteVote(scope)" v-if="scope.row.status!=2">删除</el-dropdown-item>
								<el-dropdown-item command="list" @click.native="voteLog(scope.row)">投票记录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<div class="pagination-l">
					共{{total}}条记录
				</div>
				<el-pagination
				@current-change="handleCurrentChange"
				background
				:total=this.total
				:page-size= this.pageSize
				layout="prev, pager, next, jumper"
				hide-on-single-page
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		ajaxParam
	} from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import VoteListModel from '@/modules/vote/voteList.js'
	export default {
		name: 'VoteList',
		components: {
			Title
		},
		mixins: [
			VoteListModel
		],
		data() {
			return {
				
			}
		},
		created() {
			
		},
		methods: {
			setSelectedOptions(e){
				console.log(e)
				this.status = e
				this.getVoteList()
			},
			toSearch() {
				this.getActivityList()
			},
			toReset() {
				this.status = ''
				this.pageNum = 1
				this.voteList = []
				this.getVoteList()
			},
			addVote() {
				this.$router.push({
					path: '/admin/addSelection'
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap /deep/ .el-table .el-table__cell {
		padding: 6px 0 !important;
		font-size: 12px;
	}

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}

	.pagination {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
		overflow: hidden;
		.pagination-l{
			font-size: 12px;
		}
	}

	.title /deep/ .el-button--warning {
		background-color: #EB6B1B
	}

	.title /deep/ .el-button--mini {
		padding: 4px 10px;
	}

	.activity-form-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
	}

	.dropdown-new {
		li {
			height: 26px;
			line-height: 26px;
			font-size: 12px;
			color: #EB6B1B;
		}

		li:hover {
			background: none;
			text-decoration: underline;
			color: #EB6B1B;
		}
	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px !important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}

	/deep/ .el-dropdown {
		color: #EB6B1B;
	}
	/deep/ .el-switch.is-disabled {
	 opacity: 1;
	}
	/deep/ .el-switch.is-disabled .el-switch__core, /deep/ .el-switch.is-disabled .el-switch__label {
	  cursor: pointer !important;;
	}

</style>